export const translations = {
  id: {
    nav: {
      about: "Tentang",
      services: "Layanan",
      why: "Keunggulan",
      process: "Proses",
      gallery: "Galeri",
      contact: "Kontak",
      cta: "Hubungi Kami",
    },
    hero: {
      overline: "PT MAHAKAIN SUTERA NIRMALA",
      titleTop: "Kain",
      titleBottom: "Keunggulan",
      subtitle:
        "Manufaktur pakaian jadi & konveksi tekstil kelas dunia — memadukan skala industri dengan keahlian jahit yang teliti dari jantung Jakarta.",
      cta: "Temukan Karya Kami",
      ctaSecondary: "Lihat Layanan",
      stat1: "Tahun Pengalaman",
      stat1v: "15+",
      stat2: "Potong / Bulan",
      stat2v: "500K+",
      stat3: "Klien Korporat",
      stat3v: "120+",
    },
    about: {
      overline: "Tentang Kami",
      title: "Tentang MAHAKAIN",
      text: "PT MAHAKAIN SUTERA NIRMALA menjembatani manufaktur skala industri dengan keahlian kerajinan tekstil yang murni. Kami memproduksi pakaian jadi berkualitas tinggi untuk merek dan korporasi yang menuntut presisi, konsistensi, dan hasil akhir yang sempurna.",
      text2:
        "Dari pemilihan kain hingga penyelesaian akhir, setiap tahap dikerjakan dengan standar mutu yang ketat oleh tim berpengalaman kami.",
      point1: "Kontrol kualitas menyeluruh di setiap lini",
      point2: "Kapasitas produksi skala besar yang andal",
      point3: "Sumber kain premium & etis",
    },
    services: {
      overline: "Apa yang Kami Kerjakan",
      title: "Keahlian Kami",
      subtitle:
        "Solusi manufaktur pakaian jadi menyeluruh, dirancang untuk merek dan institusi.",
      items: [
        {
          title: "Cut-Make-Trim (CMT)",
          desc: "Layanan potong, jahit, dan penyelesaian terintegrasi dengan presisi tinggi untuk produksi massal maupun batch kecil.",
        },
        {
          title: "Seragam Korporat",
          desc: "Seragam kerja, korporat, dan institusi yang tahan lama, nyaman, dan mencerminkan identitas merek Anda.",
        },
        {
          title: "Produksi Tekstil",
          desc: "Manufaktur tekstil terkontrol dari bahan mentah hingga produk jadi dengan konsistensi warna dan mutu.",
        },
        {
          title: "Penyediaan Kain",
          desc: "Sourcing kain premium dari jaringan pemasok tepercaya kami, sesuai spesifikasi dan anggaran Anda.",
        },
      ],
    },
    why: {
      overline: "Mengapa MAHAKAIN",
      title: "Keunggulan Kami",
      items: [
        { title: "Presisi & Konsistensi", desc: "Standar mutu yang terukur di setiap potong pakaian." },
        { title: "Kapasitas Skala Besar", desc: "Infrastruktur produksi untuk memenuhi pesanan dalam jumlah besar tepat waktu." },
        { title: "Pengerjaan Teliti", desc: "Perpaduan tenaga ahli dan teknologi mesin modern." },
        { title: "Ketepatan Waktu", desc: "Manajemen produksi yang menjamin pengiriman sesuai jadwal." },
      ],
    },
    process: {
      overline: "Cara Kami Bekerja",
      title: "Proses Produksi",
      steps: [
        { title: "Konsultasi & Desain", desc: "Memahami kebutuhan, spesifikasi, dan target Anda secara mendetail." },
        { title: "Pemilihan Kain", desc: "Menentukan material terbaik sesuai fungsi, kenyamanan, dan anggaran." },
        { title: "Sampling & Approval", desc: "Membuat sampel untuk persetujuan sebelum produksi massal dimulai." },
        { title: "Produksi & QC", desc: "Produksi terkontrol dengan pemeriksaan kualitas di setiap tahap." },
        { title: "Finishing & Pengiriman", desc: "Penyelesaian akhir, pengemasan, dan pengiriman tepat waktu." },
      ],
    },
    gallery: {
      overline: "Karya Kami",
      title: "Galeri Produk",
      subtitle: "Sekilas hasil produksi dan proses di fasilitas kami.",
    },
    testimonials: {
      overline: "Kepercayaan Klien",
      title: "Apa Kata Mereka",
      items: [
        { quote: "Kualitas jahitan dan ketepatan waktu MAHAKAIN sangat konsisten. Mitra produksi yang benar-benar bisa diandalkan.", name: "Direktur Operasional", role: "Merek Fashion Nasional" },
        { quote: "Seragam korporat kami dikerjakan rapi dengan hasil akhir premium. Tim mereka sangat responsif.", name: "HR Manager", role: "Perusahaan Energi" },
        { quote: "Dari sampling hingga produksi massal, semuanya berjalan mulus dan profesional.", name: "Founder", role: "Label Pakaian" },
      ],
    },
    contact: {
      overline: "Mari Berkolaborasi",
      title: "Hubungi Kami",
      subtitle: "Sampaikan kebutuhan produksi Anda — tim kami akan segera menindaklanjuti.",
      name: "Nama Lengkap",
      email: "Alamat Email",
      company: "Perusahaan (opsional)",
      subject: "Subjek",
      message: "Pesan Anda",
      submit: "Kirim Pesan",
      submitting: "Mengirim...",
      success: "Terima kasih! Pesan Anda telah terkirim.",
      error: "Terjadi kesalahan. Silakan coba lagi.",
      addressLabel: "Kantor Kami",
    },
    footer: {
      tagline: "Kain Keunggulan.",
      rights: "Seluruh hak cipta dilindungi.",
      nav: "Navigasi",
      company: "Perusahaan",
    },
  },
  en: {
    nav: {
      about: "About",
      services: "Services",
      why: "Why Us",
      process: "Process",
      gallery: "Gallery",
      contact: "Contact",
      cta: "Get in Touch",
    },
    hero: {
      overline: "PT MAHAKAIN SUTERA NIRMALA",
      titleTop: "The Fabric",
      titleBottom: "of Excellence",
      subtitle:
        "World-class garment manufacturing & textile convection — merging industrial scale with meticulous tailoring craft, from the heart of Jakarta.",
      cta: "Discover Our Craft",
      ctaSecondary: "View Services",
      stat1: "Years of Craft",
      stat1v: "15+",
      stat2: "Pieces / Month",
      stat2v: "500K+",
      stat3: "Corporate Clients",
      stat3v: "120+",
    },
    about: {
      overline: "About Us",
      title: "About MAHAKAIN",
      text: "PT MAHAKAIN SUTERA NIRMALA bridges the gap between industrial scale manufacturing and pristine textile craftsmanship. We produce high-quality garments for brands and corporations that demand precision, consistency, and a flawless finish.",
      text2:
        "From fabric selection to final finishing, every stage is executed to exacting quality standards by our experienced team.",
      point1: "End-to-end quality control on every line",
      point2: "Reliable large-scale production capacity",
      point3: "Premium & ethical fabric sourcing",
    },
    services: {
      overline: "What We Do",
      title: "Our Expertise",
      subtitle:
        "Comprehensive garment manufacturing solutions, engineered for brands and institutions.",
      items: [
        {
          title: "Cut-Make-Trim (CMT)",
          desc: "Integrated cutting, sewing, and finishing services with high precision for mass and small-batch production.",
        },
        {
          title: "Corporate Uniforms",
          desc: "Durable, comfortable work, corporate, and institutional uniforms that reflect your brand identity.",
        },
        {
          title: "Textile Production",
          desc: "Controlled textile manufacturing from raw material to finished product with consistent color and quality.",
        },
        {
          title: "Fabric Sourcing",
          desc: "Premium fabric sourcing from our trusted supplier network, matched to your spec and budget.",
        },
      ],
    },
    why: {
      overline: "Why MAHAKAIN",
      title: "Why Choose Us",
      items: [
        { title: "Precision & Consistency", desc: "Measurable quality standards on every single garment." },
        { title: "Large-Scale Capacity", desc: "Production infrastructure to fulfil high-volume orders on time." },
        { title: "Meticulous Craft", desc: "A blend of skilled artisans and modern machine technology." },
        { title: "On-Time Delivery", desc: "Production management that guarantees on-schedule shipping." },
      ],
    },
    process: {
      overline: "How We Work",
      title: "Production Process",
      steps: [
        { title: "Consultation & Design", desc: "Understanding your needs, specifications, and targets in detail." },
        { title: "Fabric Selection", desc: "Choosing the best material for function, comfort, and budget." },
        { title: "Sampling & Approval", desc: "Producing samples for approval before mass production begins." },
        { title: "Production & QC", desc: "Controlled production with quality checks at every stage." },
        { title: "Finishing & Delivery", desc: "Final finishing, packaging, and on-time delivery." },
      ],
    },
    gallery: {
      overline: "Our Work",
      title: "Product Gallery",
      subtitle: "A glimpse of our production output and facility process.",
    },
    testimonials: {
      overline: "Client Trust",
      title: "What They Say",
      items: [
        { quote: "MAHAKAIN's stitching quality and punctuality are remarkably consistent. A truly dependable production partner.", name: "Operations Director", role: "National Fashion Brand" },
        { quote: "Our corporate uniforms were crafted neatly with a premium finish. Their team is highly responsive.", name: "HR Manager", role: "Energy Company" },
        { quote: "From sampling to mass production, everything ran smoothly and professionally.", name: "Founder", role: "Apparel Label" },
      ],
    },
    contact: {
      overline: "Let's Collaborate",
      title: "Get in Touch",
      subtitle: "Tell us about your production needs — our team will follow up promptly.",
      name: "Full Name",
      email: "Email Address",
      company: "Company (optional)",
      subject: "Subject",
      message: "Your Message",
      submit: "Send Message",
      submitting: "Sending...",
      success: "Thank you! Your message has been sent.",
      error: "Something went wrong. Please try again.",
      addressLabel: "Our Office",
    },
    footer: {
      tagline: "The Fabric of Excellence.",
      rights: "All rights reserved.",
      nav: "Navigation",
      company: "Company",
    },
  },
};

export const ADDRESS =
  "Lt. 21 Unit G, Jl. H.R. Rasuna Said, Blok X-5 Kav. 1-2, RT 001/RW 002, Kelurahan Kuningan Timur, Kecamatan Setiabudi, Kota Administrasi Jakarta Selatan, Provinsi DKI Jakarta, Kode Pos: 12950";
